
import Vue from 'vue'
import {
  Component, Prop,
} from 'vue-property-decorator'
import i18n from '../plugins/i18n'

@Component({})
export default class Card extends Vue {
  @Prop({ default: 'none' }) cardType!: string
  @Prop({ default: '**** **** **** ****' }) cardNumber!: string
  @Prop({ default: '***** ****' }) cardHolder!: string
  @Prop({ default: () => i18n.t('message.monthYear') }) validThru!: string
  @Prop({ default: 'CVV' }) cvv!: string

  goBack() {
    const front = this.$refs.front as Element
    const back = this.$refs.back as Element

    front.classList.remove('back')
    front.classList.add('front')
    back.classList.remove('front')
    back.classList.add('back')
  }

  goFront() {
    const front = this.$refs.front as Element
    const back = this.$refs.back as Element

    front.classList.add('back')
    front.classList.remove('front')
    back.classList.add('front')
    back.classList.remove('back')
  }
}
